import React from 'react';
import { ShoppingBagIcon, Trash2Icon, CheckCircle2Icon } from 'lucide-react';
import { CartLine } from '../../hooks/useCart';
export type Fulfilment = 'camion' | 'labo';
interface CartPanelProps {
  lines: CartLine[];
  count: number;
  total: number;
  fulfilment: Fulfilment;
  slot: string;
  slots: string[];
  submitted: boolean;
  onSlotChange: (slot: string) => void;
  onClear: () => void;
  onSubmit: () => void;
}
export function CartPanel({
  lines,
  count,
  total,
  fulfilment,
  slot,
  slots,
  submitted,
  onSlotChange,
  onClear,
  onSubmit
}: CartPanelProps) {
  const isEmpty = lines.length === 0;
  return <aside aria-label="Votre commande" className="border-[3px] border-noir bg-white shadow-hard lg:sticky lg:top-28" data-id="element-196" data-mp="3ich1j9jkeshj">
      <h2 className="flex items-center gap-2 border-b-[3px] border-noir bg-noir px-4 py-3 font-display text-lg uppercase text-jaune" data-id="element-197" data-mp="3nccxcli3zdm0">
        <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-198" data-mp="1ljf6uwbt0x48" />
        Votre commande
        <span className="ml-auto border-2 border-jaune px-2 text-sm" data-id="element-199" data-mp="3729twoqc2w25">{count}</span>
      </h2>

      {submitted ? <div className="p-6 text-center" data-id="element-200" data-mp="331pvzixxroey">
          <CheckCircle2Icon className="mx-auto h-10 w-10 text-canard" aria-hidden="true" data-id="element-201" data-mp="330o98h7k5dhe" />
          <p className="mt-3 font-display text-xl uppercase leading-tight" data-id="element-202" data-mp="3grt83h33q1qo">Commande envoyée !</p>
          <p className="mt-2 text-sm text-noir/70" data-id="element-203" data-mp="3btrsx78sqmkh">
            Vous recevrez un SMS de confirmation. Retrait{' '}
            {fulfilment === 'camion' ? 'au camion' : 'au laboratoire'} à {slot}.
          </p>
        </div> : isEmpty ? <p className="px-4 py-8 text-center text-sm text-noir/60" data-id="element-204" data-mp="2y1k0frojphrl">
          Votre panier est vide. Choisissez vos tourtes dans la carte.
        </p> : <>
          <ul className="divide-y divide-noir/10" data-id="element-205" data-mp="2t4thmwlcw82h">
            {lines.map(line => <li key={line.item.id} className="flex items-baseline gap-3 px-4 py-3" data-id="element-206" data-mp="d9roybs6p4l7">
                <span className="border-2 border-noir px-1.5 font-display text-sm leading-tight" data-id="element-207" data-mp="8bzsr5kiawb7">
                  {line.quantity}
                </span>
                <span className="min-w-0 flex-1" data-id="element-208" data-mp="ke9ixmj15wv8">
                  <span className="block truncate text-sm font-semibold" data-id="element-209" data-mp="kczk2v4csknj">{line.item.name}</span>
                  <span className="text-xs uppercase tracking-[0.1em] text-noir/50" data-id="element-210" data-mp="peouq9nnywb3">
                    {line.item.origin}
                  </span>
                </span>
                <span className="text-sm font-bold" data-id="element-211" data-mp="3svnhwsmej0ts">
                  {(line.quantity * line.item.price).toFixed(2).replace('.', ',')} €
                </span>
              </li>)}
          </ul>

          <div className="border-t-[3px] border-noir px-4 py-4" data-id="element-212" data-mp="6mmaypfq6zwm">
            <div className="flex items-baseline justify-between" data-id="element-213" data-mp="bemh4zme2p1n">
              <span className="font-display text-lg uppercase" data-id="element-214" data-mp="bg78yhhbjtvt">Total</span>
              <span className="font-display text-2xl" data-id="element-215" data-mp="3a3l9g4jwyqum">
                {total.toFixed(2).replace('.', ',')} €
              </span>
            </div>

            <label className="mt-4 block" data-id="element-216" data-mp="37jetszlxtby8">
              <span className="text-xs font-bold uppercase tracking-[0.12em] text-noir/60" data-id="element-217" data-mp="37idgspld2fdv">
                Créneau de retrait
              </span>
              <select value={slot} onChange={event => onSlotChange(event.target.value)} className="mt-1.5 w-full border-[3px] border-noir bg-creme px-3 py-2 font-semibold" data-id="element-218" data-mp="2xlipaqni9f93">
                {slots.map(option => <option key={option} value={option} data-id="element-219" data-mp="2omngd6t2tr23">
                    {option}
                  </option>)}
              </select>
            </label>

            <button type="button" onClick={onSubmit} className="mt-4 w-full border-[3px] border-noir bg-rouge py-3 font-display text-base uppercase text-creme transition-transform duration-150 ease-out hover:-translate-y-0.5" data-id="element-220" data-mp="2evj083ro005o">
              Payer et réserver
            </button>
            <button type="button" onClick={onClear} className="mt-2 flex w-full items-center justify-center gap-1.5 py-1 text-xs font-semibold uppercase tracking-wide text-noir/55 transition-colors duration-150 ease-out hover:text-rouge" data-id="element-221" data-mp="20xm57bsv01t4">
              <Trash2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-222" data-mp="2grrfm7fpucy6" />
              Vider le panier
            </button>
            <p className="mt-3 text-center text-[11px] leading-snug text-noir/50" data-id="element-223" data-mp="26vo3c8r5gxxi">
              Paiement sur place ou en ligne. Aucun frais de service.
            </p>
          </div>
        </>}
    </aside>;
}